export default {
    units: {
        szt: 'szt.',
        opak: 'opak.',
        peczek: 'pęczek',
    },
    noCategory: 'Bez kategorii',
    firstSteps: {
        start: {
            title: 'Szybki start',
            action: 'Skonfiguruj',
            what: 'Zaznacz sklepy, do których chodzisz (Lidl, Rossmann, IKEA…), i gotowe szablony.',
            why: 'Sklepy dostaną swoje działy i kolejność półek, a listy na konkretny sklep i szablony ułożą się same — bez ustawiania wszystkiego po kolei.',
        },
        quantity: {
            title: 'Pozycja z ilością',
            action: 'Pokaż, jak',
            what: 'Wpisz np. „2 l mleko" albo „jajka 10 szt." — ilość i jednostka rozpoznają się same.',
            why: 'Ta sama rzecz dodana drugi raz zwiększy ilość zamiast dublować pozycję, a w sklepie od razu widać, ile wziąć.',
        },
        dictation: {
            title: 'Podyktuj listę',
            action: 'Podyktuj',
            what: 'Powiedz albo wklej całą listę naraz: „dwa litry mleka, chleb, pół kilo sera".',
            why: 'Najszybciej przy dłuższej liście — każdą pozycję zobaczysz i poprawisz, zanim trafi na listę.',
        },
        ingredients: {
            title: 'Składniki z posiłku',
            action: 'Wybierz posiłek',
            what: 'Wybierz posiłek i liczbę porcji — dodamy jego składniki, zsumowane z innymi posiłkami.',
            why: 'Gotujesz z planu i nie przepisujesz przepisu. Odznaczysz to, co masz w domu, a pozycja pokaże, do czego jest.',
        },
        list: {
            title: 'Druga lista',
            action: 'Nowa lista',
            what: 'Osobna lista na okazję: „Na grilla", „Impreza", „Remont" — nie na sklep, bo każda lista działa w każdym sklepie.',
            why: 'Bieżące zakupy nie mieszają się z większymi planami. Pozycję przeniesiesz między listami jednym ruchem.',
        },
        template: {
            title: 'Szablon',
            action: 'Nowy szablon',
            what: 'Zestaw, który kupujesz regularnie — np. „Tygodniowe".',
            why: 'Raz ułożony, potem jednym tapnięciem trafia na listę — bez rzeczy, które masz jeszcze w domu.',
        },
        kind: {
            title: 'Rodzaj sklepu',
            action: 'Utwórz rodzaj',
            what: '„Spożywczy" dla Lidla i Biedronki, „Drogeria" dla Rossmanna — z gotowca, działy dobiorą się same.',
            why: 'W drogerii nie zobaczysz w trybie zakupów chleba, a w Lidlu szamponu — trafią do „Gdzie indziej" z podpowiedzią, gdzie je kupisz.',
        },
        layout: {
            title: 'Półki w Twoim sklepie',
            action: 'Ułóż półki',
            what: 'Kolejność działów w sklepie, do którego chodzisz najczęściej — każdy sklep może mieć własną.',
            why: 'W trybie zakupów idziesz przez sklep raz, od wejścia do kasy: w Lidlu od warzyw, w Biedronce od lodówek.',
        },
        trip: {
            title: 'Pierwsze zakupy',
            action: 'Na zakupy',
            what: 'Tryb zakupów: odhaczasz, co wkładasz do koszyka, a na koniec „Zakończ zakupy".',
            why: 'Kupione trafiają do historii — stąd biorą się ostatnie ceny i „Kupuję często". Działa też bez zasięgu.',
        },
        expense: {
            title: 'Wydatek w Portfelu',
            action: 'Pokaż, jak',
            what: 'Po zakupach zapisz wydatek w Portfelu — kwota podpowie się z cen pozycji.',
            why: 'Zakupy od razu odliczają się od „Do wydania", bez przepisywania paragonu.',
        },
    },
    help: {
        add: {
            title: 'Dodawanie',
            text: 'Wpisz, co kupić — rozumiemy „2 l mleko", „jajka 10 szt." i kilka rzeczy po przecinku. Podpowiadamy to, co już było kupowane, z ostatnią ceną.',
            more: 'Ta sama rzecz dodana drugi raz (ta sama jednostka) zwiększa ilość, a nie dubluje pozycji. Kategoria podpowiada się sama — taka, jak ostatnio dla tej nazwy. Pod polem: podyktuj całą listę, dodaj składniki posiłku, wybierz z „Kupuję często" albo z szablonu.',
        },
        shortcuts: {
            title: 'Szybciej niż pisanie',
            text: 'Podyktuj całą listę naraz, dodaj składniki posiłku, wybierz z „Kupuję często" albo z szablonu. Zawsze najpierw zobaczysz podgląd.',
        },
        list: {
            title: 'Lista',
            text: 'Pozycje w kolejności półek, pilne na górze. Kółko odhacza, tapnięcie w nazwę otwiera szczegóły: ilość, cenę, zamiennik, „tylko w" sklepie.',
            more: 'Przełącznik nad listą zmienia układ na kolejność dodania. „Nie było" zostaje na liście z datą, żeby pamiętać, gdzie szukać.',
        },
        inBasket: {
            title: 'W koszyku',
            text: 'Odhaczone pozycje. „Zakończ zakupy" przenosi je do historii, a reszta czeka na następny raz.',
        },
        quickStart: {
            title: 'Szybki start',
            text: 'Ustawia Koszyk z gotowych zestawów: zaznaczasz sklepy, do których chodzisz, listy na konkretny sklep i szablony — rodzaje sklepów, ich działy i kolejność półek zakładają się same.',
            more: 'Niczego nie dubluje: sklep, rodzaj, kategoria czy lista o tej samej nazwie, którą już masz, zostaje bez zmian. Możesz go uruchomić ponownie, żeby dołożyć kolejne sklepy.',
        },
        qsStores: {
            title: 'Gdzie robisz zakupy',
            text: 'Każdy zaznaczony sklep dostaje swój rodzaj — Spożywczy, Drogeria, Sportowy… — z działami w typowej kolejności. Dzięki temu w trybie zakupów zobaczysz w nim tylko to, co da się tam kupić.',
            more: 'Lidl i Biedronka dostaną ten sam rodzaj „Spożywczy", więc zmiana działów w rodzaju zadziała w obu. Kolejność półek pod konkretny sklep ułożysz potem w zakładce Sklepy.',
        },
        qsLists: {
            title: 'Listy na konkretny sklep',
            text: 'Lista „Sport · Decathlon" jest na jeden sklep: jej rzeczy zobaczysz tylko w rozpisce Decathlonu, a nie przy zakupach w Lidlu. Lista pokazuje się, gdy zaznaczysz jej sklep.',
            more: '„Bieżące" masz zawsze — to lista na wszystkie sklepy, na codzienne zakupy. Sklep każdej listy zmienisz później przy jej edycji.',
        },
        qsTemplates: {
            title: 'Szablony',
            text: 'Gotowe zestawy pozycji z kategoriami, np. „Tygodniowe" albo „Grill". Na liście wybierasz „Z szablonu", odznaczasz to, co masz w domu, i reszta trafia na listę.',
            more: 'Szablon zmienisz albo usuniesz w zakładce „Listy i szablony”.',
        },
        trip: {
            title: 'Na zakupy',
            text: 'Wybierasz, gdzie jesteś — i dostajesz rozpiskę tego sklepu: wszystko, co masz tam kupić, ze wszystkich list naraz, w kolejności jego półek. Duże pola łatwo odhaczyć, działa też bez zasięgu.',
            more: 'Z list tego sklepu bierze wszystko, z list bez sklepu (jak „Bieżące") to, co się tam kupi. Rzeczy z list innych sklepów, które też tu są, czekają w zwiniętym „Z innych list". „Zakończ zakupy" robi z tego jedne zakupy w historii.',
        },
        lists: {
            title: 'Listy',
            text: 'Lista mówi, co kupić — osobna na okazję: „Bieżące", „Na grilla", „Remont". Zwykle jest na wszystkie sklepy; listę na jeden sklep (np. „Sport · Decathlon") zrobisz, wybierając jej sklep. Domyślna to ta, na którą trafia wszystko dodane w biegu.',
            more: 'Listę po zakupach możesz odłożyć do archiwum — wróci jednym tapnięciem.',
        },
        listVsStore: {
            title: 'Lista a sklep',
            text: 'Po lewej lista — co kupić. Po prawej sklep jako droga od wejścia do kasy przez jego działy, a Twoje pozycje leżą w swoich działach. Przełącz sklep: ta sama lista ułoży się inaczej, a czego tam nie kupisz (szampon w Lidlu), czeka w „Gdzie indziej" z podpowiedzią, gdzie to dostać.',
            more: 'Lista może mieć swój sklep — „Sport" na Decathlon. Jej rzeczy zobaczysz wtedy tylko w Decathlonie, a „Bieżące" (bez sklepu) w każdym sklepie, w którym to kupisz.',
        },
        templates: {
            title: 'Szablony',
            text: 'Gotowe zestawy, np. „Tygodniowe" albo „Impreza". „Użyj" pokazuje pozycje do odznaczenia tego, co masz w domu, i dodaje resztę na listę.',
        },
        archive: {
            title: 'Archiwum',
            text: 'Listy odłożone po zakupach. Możesz je przywrócić albo usunąć na stałe.',
        },
        frequent: {
            title: 'Kupuję często',
            text: 'To, co kupujesz najczęściej w ostatnich miesiącach. Tapnięcie dodaje na listę domyślną z ilością z ostatniego razu.',
        },
        history: {
            title: 'Zakupy',
            text: 'Każde zakończone zakupy: gdzie, z jakiej listy, co kupione i za ile. Stąd też zapiszesz wydatek w Portfelu, jeśli nie został zapisany od razu.',
            more: 'Z historii biorą się ostatnie ceny, „Kupuję często" i podpowiedzi kategorii.',
        },
        stores: {
            title: 'Sklepy',
            text: 'Sklep mówi, gdzie kupujesz. „Jestem tutaj" pokazuje wszystko, co masz w nim kupić. Każdy sklep ma rodzaj i swoją kolejność półek. Rodzaj mówi, jakie działy w nim są (Lidl — spożywczy, Rossmann — drogeria). „Półki" układają te działy w kolejności, w jakiej je mijasz: w Lidlu najpierw warzywa, w Biedronce lodówki.',
            more: 'Bez własnej kolejności sklep bierze kolejność swojego rodzaju, a bez rodzaju — wszystkie kategorie w kolejności ogólnej.',
        },
        kinds: {
            title: 'Rodzaje sklepów',
            text: 'Rodzaj to zestaw działów, które ma taki sklep: „Spożywczy" (warzywa, pieczywo, nabiał…) dla Lidla i Biedronki, „Drogeria" (kosmetyki, higiena…) dla Rossmanna. Układasz go raz i przypinasz do wielu sklepów.',
            more: 'Działu spoza rodzaju nie ma w tym sklepie — w trybie zakupów jego pozycje czekają w „Gdzie indziej". Dodanie działu do rodzaju działa od razu we wszystkich jego sklepach.',
        },
        defaultList: {
            title: 'Lista domyślna',
            text: 'Na nią trafia to, co dodajesz bez wybierania listy — dyktowanie, „Kupuję często", przycisk na górnym pasku.',
        },
        oldList: {
            title: 'Stara lista zakupowa',
            text: 'Możesz raz skopiować pozycje ze starej listy — posiłki rozbijemy na składniki. Stara lista zostaje bez zmian.',
        },
        categories: {
            title: 'Kategorie sklepowe',
            text: 'Działy sklepu (Nabiał, Pieczywo, Kosmetyki…). Pozycja ma jedną kategorię we wszystkich sklepach — mleko to Nabiał i w Lidlu, i w Biedronce. Wspólne ze starą listą zakupową.',
            more: 'Kolejność tutaj obowiązuje w sklepach bez rodzaju. Nowa kategoria zapamiętuje się dla nazwy: następnym razem „mleko" samo trafi do Nabiału.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Koszyku',
            text: 'Listy zakupów, które same się układają w kolejności półek, pamiętają ceny i działają w sklepie bez zasięgu. W minutę pokażę, co gdzie jest.',
        },
        done: {
            title: 'To wszystko',
            text: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy każdej sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    quickStartDone: {
        stores: '{n} sklep | {n} sklepy | {n} sklepów',
        kinds: '{n} rodzaj | {n} rodzaje | {n} rodzajów',
        categories: '{n} kategoria | {n} kategorie | {n} kategorii',
        lists: '{n} lista | {n} listy | {n} list',
        templates: '{n} szablon | {n} szablony | {n} szablonów',
        created: 'Założone: {parts}.',
        nothing: 'Wszystko już było — nic nie trzeba było zakładać.',
    },
    list: {
        moduleTitle: 'Koszyk',
        legacyBanner: 'Masz {n} rzecz na starej liście zakupowej — przenieś ją do Koszyka. | Masz {n} rzeczy na starej liście zakupowej — przenieś je do Koszyka. | Masz {n} rzeczy na starej liście zakupowej — przenieś je do Koszyka.',
        legacyMove: 'Przenieś',
        legacyNo: 'Nie, dzięki',
        subtitleTemplate: 'szablon · {n} pozycja | szablon · {n} pozycje | szablon · {n} pozycji',
        subtitleStore: 'lista na {store}',
        subtitleToBuy: '{n} do kupienia',
        subtitleCost: 'ok. {amount}',
        mergedNow: '{name}: teraz {quantity}',
        alreadyOnList: '{name} już jest na liście',
        mergedSummary: 'Dodane: {added}, połączone z tym, co już było: {merged}.',
        addFailed: 'Nie udało się dodać.',
        saveFailedConnection: 'Nie udało się zapisać — sprawdź połączenie.',
        fromTemplateTitle: 'Z szablonu „{name}”',
        useTemplateTitle: 'Z szablonu „{name}"',
        uncheckAtHome: 'Odznacz to, co masz w domu.',
        addedElsewhere: 'Dodane: {count} — w tym {lists}.',
        addedTo: 'Dodane na „{name}": {count}.',
        addedToMerged: 'Dodane na „{name}": {count} ({merged} połączone z tym, co było).',
        deleted: 'Usunięte.',
        tripFinished: 'Zakupy zakończone: {n} pozycja w historii. | Zakupy zakończone: {n} pozycje w historii. | Zakupy zakończone: {n} pozycji w historii.',
        expenseSaved: 'Wydatek zapisany w Portfelu.',
        finishFailed: 'Nie udało się zakończyć zakupów.',
        form: {
            name: 'Nazwa',
            namePlaceholder: 'np. Na grilla',
            store: 'Sklep tej listy',
            storeHint: 'Lista na jeden sklep (np. Sport → Decathlon): jej rzeczy zobaczysz tylko w nim. Puste — lista na wszystkie sklepy, jak „Bieżące".',
            isDefault: 'Domyślna',
            isDefaultHint: 'Tu trafia wszystko dodane w biegu',
            templateName: '{name} — szablon',
        },
        listSaved: 'Lista zapisana.',
        listCreated: 'Nowa lista „{name}".',
        templateSaved: 'Szablon „{name}" zapisany ({n} poz.).',
        saveFailed: 'Nie udało się zapisać.',
        allUnchecked: 'Wszystko odznaczone.',
        quantityHint: {
            title: 'Pozycja z ilością',
            text: 'Wpisz np. „2 l mleko" albo „jajka 10 szt." i Enter. Kilka rzeczy naraz rozdziel przecinkami.',
        },
        listPlaceholder: 'Lista',
        more: 'Więcej',
        menu: {
            edit: 'Edytuj listę',
            new: 'Nowa lista',
            saveAsTemplate: 'Zapisz jako szablon',
            uncheckAll: 'Odznacz wszystko',
            allLists: 'Wszystkie listy',
        },
        goShopping: 'Na zakupy',
        useTemplate: 'Użyj szablonu',
        templateItemsTitle: 'POZYCJE SZABLONU',
        addTitle: 'DODAJ',
        quickStartCard: {
            title: 'Szybki start — ustaw Koszyk w minutę',
            text: 'Zaznacz sklepy, do których chodzisz, i gotowe szablony — działy, kolejność półek i listy ułożą się same.',
            button: 'Zaczynamy',
        },
        templateTitle: 'SZABLON',
        toBuyTitle: 'DO KUPIENIA',
        layout: {
            label: 'Układ listy',
            shelf: 'Półki',
            added: 'Kolejność',
        },
        emptyTemplate: 'Dodaj pozycje, które mają wchodzić na listę z tym szablonem.',
        empty: 'Lista jest pusta. Wpisz coś wyżej — np. „mleko, chleb, 10 jajek".',
        allInBasket: 'Wszystko w koszyku.',
        urgentTitle: 'PILNE',
        estimate: 'Szacunkowo {total} — z cen pozycji albo ostatnio zapłaconych.',
        estimateMissing: 'Szacunkowo {total} · bez ceny: {missing} — z cen pozycji albo ostatnio zapłaconych.',
        inBasketTitle: 'W KOSZYKU · {n}',
        finish: 'Zakończ zakupy',
        fromDictation: 'Z dyktowania',
        fromDictationHint: 'Sprawdź, popraw i dodaj.',
        ingredients: 'Składniki',
        ingredientsFor: 'do: {names}',
        dialog: {
            edit: 'Lista',
            new: 'Nowa lista',
            template: 'Zapisz jako szablon',
        },
        undo: 'Cofnij',
    },
    history: {
        title: 'Historia',
        thisMonth: 'w tym miesiącu {amount}',
        addedToDefault: '„{name}" na liście „{list}".',
        addFailed: 'Nie udało się dodać.',
        expenseSaved: 'Wydatek zapisany w Portfelu.',
        expenseHint: {
            title: 'Wydatek w Portfelu',
            text: 'Po „Zakończ zakupy" od razu zaproponujemy wydatek z kwotą z cen pozycji. Tutaj zapiszesz go później: „Zapisz w Portfelu" przy zakupach.',
        },
        frequentTitle: 'KUPUJĘ CZĘSTO',
        boughtTimes: 'Kupione {n}× w ostatnich miesiącach',
        frequentEmpty: 'Pojawi się po pierwszych zakupach zakończonych w trybie zakupów.',
        tripsTitle: 'ZAKUPY',
        itemCount: '{n} pozycja | {n} pozycje | {n} pozycji',
        pricedOf: 'ceny {priced} z {count}',
        expenseSavedTitle: 'Wydatek zapisany w Portfelu',
        wallet: 'Portfel',
        saveInWallet: 'Zapisz w Portfelu',
        remove: 'Usuń z historii',
        empty: 'Tu trafią zakupy po „Zakończ zakupy" — z tym, co kupione, gdzie i za ile.',
        removeConfirm: {
            title: 'Usunąć z historii?',
            message: 'Zakupy znikną z historii i z „Kupuję często”. Wydatek w Portfelu zostaje.',
        },
    },
    settings: {
        title: 'Ustawienia Koszyka',
        defaultSet: 'Lista domyślna: „{name}".',
        legacyEmpty: 'Stara lista zakupowa jest pusta.',
        legacyFailed: 'Nie udało się wczytać starej listy.',
        copied: 'Skopiowane: {count}. Stara lista została bez zmian.',
        defaultTitle: 'LISTA DOMYŚLNA',
        topBar: 'Przycisk Koszyka na górnym pasku też ją otwiera — {link}.',
        topBarLink: 'włącz go w ustawieniach paska',
        legacyTitle: 'STARA LISTA ZAKUPOWA',
        legacyText: 'Skopiuj to, co masz na starej liście — zobaczysz podgląd, a stara lista zostanie bez zmian.',
        legacyButton: 'Skopiuj ze starej listy',
        storesTitle: 'SKLEPY, RODZAJE I KATEGORIE',
        storesText: 'Mają teraz własną zakładkę — {link}.',
        storesLink: 'Sklepy',
        legacyProposalsTitle: 'Ze starej listy',
        legacyProposalsSubtitle: 'Posiłki są rozbite na składniki. Odznacz to, czego nie potrzebujesz.',
    },
    lists: {
        title: 'Listy i szablony',
        listCount: '{n} lista | {n} listy | {n} list',
        newList: 'Nowa lista',
        itemCount: '{n} pozycja | {n} pozycje | {n} pozycji',
        inBasket: '{n} w koszyku',
        templatePlaceholder: 'np. Tygodniowe',
        saved: 'Zapisane.',
        archived: '„{name}" w archiwum.',
        restored: '„{name}" przywrócona.',
        defaultCannotArchive: 'Listy domyślnej nie da się odłożyć — najpierw ustaw inną jako domyślną.',
        failed: 'Nie udało się.',
        nowDefault: '„{name}" jest teraz domyślna.',
        deleteFailed: 'Nie udało się usunąć.',
        listsTitle: 'LISTY',
        addList: '+ Nowa lista',
        defaultBadge: 'domyślna',
        edit: 'Edytuj',
        makeDefault: 'Domyślna',
        toArchive: 'Do archiwum',
        templatesTitle: 'SZABLONY',
        addTemplate: '+ Nowy szablon',
        templateItems: '{n} pozycja · edytuj | {n} pozycje · edytuj | {n} pozycji · edytuj',
        use: 'Użyj',
        deleteTemplate: 'Usuń szablon {name}',
        templatesEmpty: 'Zestaw rzeczy kupowanych regularnie — np. „Tygodniowe". Możesz też zapisać istniejącą listę jako szablon (menu „⋯" na liście).',
        archiveTitle: 'ARCHIWUM · {n}',
        restore: 'Przywróć',
        delete: 'Usuń',
        archiveEmpty: 'Pusto.',
        dialog: {
            template: 'Szablon',
            list: 'Lista',
            newTemplate: 'Nowy szablon',
            newList: 'Nowa lista',
        },
        deleteConfirm: 'Pozycje z listy znikną. Historia zakupów zostaje.',
    },
    stores: {
        title: 'Sklepy',
        status: {
            ownWithKind: '{kind} · własna kolejność',
            own: 'własna kolejność',
            kind: '{kind} · kolejność rodzaju',
            none: 'bez rodzaju · wszystkie kategorie',
        },
        kindSet: '{store}: {kind}.',
        kindCleared: '{store}: bez rodzaju — wszystkie kategorie.',
        kindSaveFailed: 'Nie udało się zapisać rodzaju.',
        shelvesSaved: '{store}: kolejność półek zapisana.',
        orderSaveFailed: 'Nie udało się zapisać kolejności.',
        backToKindOrder: '{store}: znów kolejność rodzaju „{kind}".',
        backToGeneralOrder: '{store}: znów kolejność ogólna.',
        addStoreFailed: 'Nie udało się dodać sklepu.',
        presets: {
            grocery: { name: 'Spożywczy', hint: 'Lidl, Biedronka — warzywa, pieczywo, nabiał…' },
            drugstore: { name: 'Drogeria', hint: 'Rossmann, Hebe — kosmetyki, higiena, chemia…' },
            sport: { name: 'Sportowy', hint: 'Decathlon, Intersport — odzież, obuwie, sprzęt…' },
            home: { name: 'Dom i meble', hint: 'IKEA, Jysk — meble, kuchnia, tekstylia…' },
            diy: { name: 'Budowlany', hint: 'Leroy Merlin, Castorama — narzędzia, farby…' },
            empty: { name: 'Pusty', hint: 'Sam wybierzesz kategorie' },
        },
        kindExists: 'Rodzaj „{name}" już jest — możesz go tu poprawić.',
        kindCreated: 'Rodzaj „{name}" z {n} kategoriami — przypnij do niego sklepy. | Rodzaj „{name}" z {n} kategoriami — przypnij do niego sklepy. | Rodzaj „{name}" z {n} kategoriami — przypnij do niego sklepy.',
        kindCreateFailed: 'Nie udało się utworzyć rodzaju.',
        kindSaved: 'Rodzaj zapisany.',
        generalOrderSaved: 'Kolejność ogólna zapisana.',
        kindHint: {
            title: 'Rodzaj sklepu',
            text: 'Utwórz „Spożywczy" (dla Lidla, Biedronki) albo „Drogerię" (dla Rossmanna) z gotowca — kategorie dobiorą się same. Potem przy sklepie wybierz jego rodzaj.',
        },
        layoutHint: {
            title: 'Półki w Twoim sklepie',
            text: 'Przy sklepie tapnij „Półki" i przeciągnij działy w kolejności, w jakiej je mijasz — od wejścia do kasy.',
            textNoStores: 'Najpierw dodaj sklep, potem tapnij przy nim „Półki" i przeciągnij działy w kolejności, w jakiej je mijasz.',
        },
        quickStart: 'Szybki start',
        storesTitle: 'SKLEPY',
        storesIntro: 'Przy każdym sklepie wybierz jego rodzaj — to mówi, które działy w nim są. „Półki" ustawiają kolejność działów w tym jednym sklepie.',
        newCategories: 'nowe: {names} — ustaw miejsce',
        noKindOption: '— bez rodzaju —',
        kindPlaceholder: 'Rodzaj sklepu',
        shelves: 'Półki',
        imHereTitle: 'Rozpiska {store}: wszystko, co tam kupić, ze wszystkich list',
        imHere: 'Jestem tutaj',
        orderOwn: 'Własna kolejność tego sklepu — przeciągnij albo użyj strzałek.',
        orderKind: 'Teraz kolejność rodzaju „{kind}". Przesuń dział, a ten sklep dostanie własną.',
        orderGeneral: 'Teraz kolejność ogólna. Przesuń dział, a sklep dostanie własną.',
        kindNoCategories: 'Ten rodzaj nie ma jeszcze kategorii — zaznacz je w „Rodzajach sklepów".',
        newBadge: 'nowa',
        moveUp: '{name}: wyżej',
        moveDown: '{name}: niżej',
        resetToKind: 'Wróć do kolejności rodzaju „{kind}"',
        resetToGeneral: 'Wróć do kolejności ogólnej',
        storesEmpty: 'Dodaj sklepy, do których chodzisz — np. Lidl, Biedronka, Rossmann.',
        newStorePlaceholder: 'Nowy sklep, np. Rossmann',
        newStoreLabel: 'Nazwa nowego sklepu',
        add: 'Dodaj',
        kindsTitle: 'RODZAJE SKLEPÓW',
        newKind: '+ Nowy rodzaj',
        kindsIntro: 'Rodzaj mówi, jakie działy ma taki sklep. Lidl i Biedronka to ten sam rodzaj, Rossmann inny. Tego, czego nie ma w rodzaju, tryb zakupów nie pokaże w tym sklepie — trafi do „Gdzie indziej".',
        kindNoStores: 'bez sklepów — przypnij je wyżej',
        deleteKind: 'Usuń rodzaj {name}',
        kindAisles: '{n} dział: {names} | {n} działy: {names} | {n} działów: {names}',
        kindsEmpty: 'Bez rodzajów każdy sklep ma wszystkie kategorie. Zacznij od gotowca „Spożywczy" albo „Drogeria".',
        categoriesTitle: 'KATEGORIE · {n}',
        categoriesIntro: 'Działy sklepu, wspólne dla wszystkich sklepów i starej listy. Kolejność tutaj to kolejność w sklepach bez rodzaju.',
        renameLabel: 'Nowa nazwa: {name}',
        rename: 'Zmień nazwę',
        deleteCategory: 'Usuń kategorię {name}',
        newCategoryPlaceholder: 'Nowa kategoria, np. Kosmetyki',
        newCategoryLabel: 'Nazwa nowej kategorii',
        deleteKindConfirm: 'Sklepy tego rodzaju będą miały wszystkie kategorie. Ich własna kolejność zostaje.',
        deleteCategoryConfirm: 'Pozycje i produkty z tą kategorią zostaną bez kategorii. Zniknie też ze starej listy zakupowej.',
    },
    addBar: {
        placeholder: 'Dodaj, np. 2 l mleko, chleb, jajka 10 szt.',
        label: 'Dodaj pozycje',
        addMany: 'Dodaj {n}',
        add: 'Dodaj',
        boughtTimes: 'kupione {n}×',
        fromCatalogue: 'z katalogu',
        wasOnList: 'było na liście',
        dictate: 'Podyktuj',
        fromMeal: 'Z posiłku',
        frequent: 'Kupuję często',
        fromTemplate: 'Z szablonu',
    },
    dictation: {
        unavailable: 'Dyktowanie jest teraz niedostępne.',
        recognisingItems: 'Rozpoznaję pozycje…',
        nothingFound: 'Nie znalazłem nic do kupienia — powiedz np. „mleko, chleb, 10 jajek".',
        recogniseFailed: 'Nie udało się rozpoznać listy.',
        noMic: 'Brak dostępu do mikrofonu.',
        silent: 'Nic nie słyszę — sprawdź mikrofon.',
        recognisingSpeech: 'Rozpoznaję mowę…',
        notRecognised: 'Nie rozpoznano mowy — spróbuj jeszcze raz.',
        uploadFailed: 'Nie udało się wysłać nagrania.',
        title: 'Podyktuj listę',
        close: 'Zamknij',
        intro: 'Powiedz albo wklej wszystko naraz — np. „dwa litry mleka bez laktozy, chleb, pół kilo sera". Zobaczysz podgląd przed dodaniem.',
        stop: 'Zakończ nagrywanie',
        record: 'Nagraj',
        orType: 'Albo wpisz / wklej',
        placeholder: 'mleko, chleb, masło, 10 jajek, coś na grilla',
        recognise: 'Rozpoznaj',
    },
    item: {
        title: 'Pozycja',
        name: 'Nazwa',
        quantity: 'Ilość',
        unit: 'Jednostka',
        note: 'Notatka',
        notePlaceholder: 'np. bez laktozy, duże',
        substitute: 'Zamiennik',
        substitutePlaceholder: 'jak nie ma, to…',
        price: 'Cena',
        lastPrice: 'Ostatnio: {price}',
        priceHint: 'Za całą pozycję',
        category: 'Kategoria',
        onlyStore: 'Tylko w sklepie',
        onlyStoreHint: 'W innym sklepie trafi do „Gdzie indziej".',
        forWhat: 'Do czego',
        forWhatPlaceholder: 'np. Leczo',
        urgent: 'Pilne',
        urgentHint: 'Na górze listy i w trybie zakupów',
        moveTo: 'Przenieś na listę',
        copyTo: 'Skopiuj też na',
        moved: 'Przeniesione na „{name}".',
        copied: 'Skopiowane na „{name}".',
        saved: 'Zapisane.',
        saveFailed: 'Nie udało się zapisać.',
        deleteFailed: 'Nie udało się usunąć.',
    },
    row: {
        substitute: 'zamiennik: {name}',
        forWhat: 'do: {name}',
        onlyAt: 'tylko w: {name}',
        uncheck: '{name}: odznacz',
        check: '{name}: w koszyku',
        urgent: 'Pilne',
        urgentLabel: 'pilne',
        missing: 'nie było',
        missingOn: 'nie było {day}',
        pending: 'Czeka na wysłanie',
        pendingLabel: 'czeka na wysłanie',
        price: 'Cena',
        lastPaid: 'Ostatnio zapłacone',
        missingButton: 'Nie było',
        details: '{name}: szczegóły',
    },
    kind: {
        title: 'Rodzaj sklepu',
        newTitle: 'Nowy rodzaj sklepu',
        close: 'Zamknij',
        intro: 'Zaznacz działy, które są w takim sklepie, i ułóż je w typowej kolejności. Każdy sklep tego rodzaju może potem mieć własną.',
        name: 'Nazwa',
        namePlaceholder: 'np. Spożywczy, Drogeria, Budowlany',
        noCategories: 'Nie masz jeszcze kategorii — dodaj je w sekcji „Kategorie".',
        count: 'W tym rodzaju: {count} z {total}',
        saving: 'Zapisuję…',
        save: 'Zapisz',
    },
    howItWorks: {
        title: 'JAK TO DZIAŁA',
        lead: '{list} mówi, co kupić. {store} — gdzie jesteś i jak iść przez działy.',
        leadList: 'Lista',
        leadStore: 'Sklep',
        listTitle: 'LISTA · CO KUPIĆ',
        exampleBadge: 'przykład',
        listFallback: 'Lista',
        example: {
            veg: 'Warzywa',
            bread: 'Pieczywo',
            dairy: 'Nabiał',
            cosmetics: 'Kosmetyki',
            hygiene: 'Higiena',
            milk: 'mleko',
            breadItem: 'chleb',
            carrots: 'marchew',
            shampoo: 'szampon',
            store1: 'Lidl',
            store2: 'Biedronka',
            store3: 'Rossmann',
            grocery: 'Spożywczy',
            drugstore: 'Drogeria',
            list: 'Bieżące',
        },
        more: '+ {n} więcej',
        listNote: 'Nie jest przypięta do sklepu — mogą tu być rzeczy z kilku sklepów naraz.',
        storeTabs: 'Sklep na schemacie',
        storeTitle: 'SKLEP · GDZIE I JAK IŚĆ',
        summaryKind: '{store}: {n} dział z rodzaju „{kind}" | {store}: {n} działy z rodzaju „{kind}" | {store}: {n} działów z rodzaju „{kind}"',
        summaryNoKind: '{store}: {n} dział — bez rodzaju, wszystkie | {store}: {n} działy — bez rodzaju, wszystkie | {store}: {n} działów — bez rodzaju, wszystkie',
        orderOwn: 'w kolejności tego sklepu',
        orderKind: 'w kolejności rodzaju',
        orderGeneral: 'w kolejności ogólnej',
        switchStore: 'Przełącz sklep — ta sama lista ułoży się inaczej.',
        pathLabel: 'Kolejność działów',
        entrance: 'Wejście',
        passing: 'mijasz',
        looseHint: 'w każdym sklepie, na końcu',
        till: 'Kasa',
        awayTitle: 'Gdzie indziej — tego nie kupisz w tym sklepie',
        buyAt: 'kupisz w: {stores}',
        notInKind: 'dział {aisle} nie jest w rodzaju tego sklepu',
        addToList: 'Dodaj coś na listę, żeby zobaczyć ją tutaj →',
        addStores: 'Dodaj swoje sklepy →',
        arrange: 'Ułóż działy tego sklepu',
        changeKind: 'Zmień rodzaj',
        chooseKind: 'Wybierz rodzaj',
        picked: {
            inKind: 'jest w rodzaju „{kind}"',
            noKind: 'sklep bez rodzaju ma wszystkie działy',
            orderOwn: 'miejsce z własnej kolejności tego sklepu',
            orderKind: 'miejsce z kolejności rodzaju',
            orderGeneral: 'miejsce z kolejności ogólnej',
            fromList: 'Z listy: {items}.',
            nothing: 'Nic z tej listy — przejdziesz obok.',
            text: '{name}: {where}, {order}. {fromList}',
        },
    },
    mealPicker: {
        loadFailed: 'Nie udało się wczytać posiłków.',
        noIngredients: 'Te posiłki nie mają składników z katalogu.',
        countFailed: 'Nie udało się policzyć składników.',
        title: 'Składniki z posiłku',
        intro: 'Zaznacz, co gotujesz, i na ile porcji. Składniki kilku posiłków się zsumują.',
        searchPlaceholder: 'Szukaj posiłku albo półproduktu…',
        searchLabel: 'Szukaj posiłku',
        loading: 'Wczytuję…',
        empty: 'Nie masz jeszcze posiłków. Dodasz je w module Jedzenie.',
        meal: 'posiłek',
        semiProduct: 'półprodukt',
        fewer: '{name}: mniej porcji',
        portions: '{n} porc.',
        more: '{name}: więcej porcji',
        chosen: 'Wybrane: {n}',
        noneChosen: 'Nic nie wybrano',
        counting: 'Liczę…',
        show: 'Pokaż składniki',
    },
    pick: {
        frequentTitle: 'Kupuję często',
        templateTitle: 'Z szablonu',
        frequentHint: 'Tapnij, żeby dodać — z ilością z ostatniego razu.',
        templateHint: 'Wybierz szablon, potem odznacz to, co masz w domu.',
        frequentEmpty: 'Tu pojawi się to, co kupujesz najczęściej — po pierwszych zakupach z trybem zakupów.',
        templatesEmpty: 'Nie masz jeszcze szablonów. Utworzysz je w zakładce „Listy i szablony” — albo zapiszesz listę jako szablon.',
        itemsShort: '{n} poz.',
    },
    proposals: {
        defaultTitle: 'Dodaj na listę',
        elsewhere: '{n} na „{list}"',
        addFailed: 'Nie udało się dodać — spróbuj jeszcze raz.',
        uncheckAll: 'Odznacz wszystko',
        checkAll: 'Zaznacz wszystko',
        uncheckHint: 'Odznacz to, co masz w domu',
        addItem: 'Dodaj: {name}',
        heard: '„{text}"',
        noCategory: 'bez kategorii',
        toList: 'na listę {list}',
        edit: 'Popraw: {name}',
        unitShort: 'Jedn.',
        nothing: 'Nic do dodania.',
        restTo: 'Reszta na',
        to: 'Na listę',
        chooseList: 'Wybierz listę',
        adding: 'Dodaję…',
    },
    quickStart: {
        loadFailed: 'Nie udało się wczytać gotowych zestawów.',
        runFailed: 'Nie udało się skonfigurować — spróbuj jeszcze raz.',
        kindHint: {
            grocery: 'warzywa, pieczywo, nabiał, mięso…',
            drugstore: 'kosmetyki, higiena, chemia…',
            sport: 'odzież, obuwie, sprzęt, rowery…',
            home: 'meble, kuchnia, tekstylia, oświetlenie…',
            diy: 'narzędzia, farby, elektryka, ogród…',
        },
        title: 'Szybki start',
        intro: 'Zaznacz, gdzie robisz zakupy i czego potrzebujesz — sklepy dostaną swoje działy i kolejność, a listy i szablony ułożą się same. To, co już masz, zostaje bez zmian.',
        storesTitle: '1. GDZIE ROBISZ ZAKUPY',
        alreadyHave: 'już masz',
        listsTitle: '2. LISTY NA KONKRETNY SKLEP',
        listsIntro: '„Bieżące" masz zawsze — na codzienne zakupy w każdym sklepie. Te listy są na jeden sklep: ich rzeczy zobaczysz tylko tam.',
        thingsFor: 'rzeczy na {store}',
        listsEmpty: 'Zaznacz Decathlon, IKEA albo Leroy Merlin, żeby dostać listę na ten sklep.',
        templatesTitle: '3. SZABLONY',
        templatesIntro: 'Gotowe zestawy — jednym tapnięciem dodasz je na listę, bez tego, co masz w domu.',
        running: 'Konfiguruję…',
        run: 'Skonfiguruj',
    },
    walletExpense: {
        enterAmount: 'Wpisz kwotę.',
        note: 'Zakupy: {list}',
        saveFailed: 'Nie udało się zapisać wydatku.',
        title: 'Wydatek w Portfelu',
        partial: 'Kwota z {priced} z {count} pozycji — popraw ją z paragonu.',
        loading: 'Wczytuję Portfel…',
        noWallet: 'Portfel nie jest jeszcze założony. {link}, a potem zapiszesz wydatek z historii zakupów.',
        noWalletLink: 'Załóż Portfel',
        amount: 'Kwota',
        account: 'Konto',
        category: 'Kategoria',
        fromReceipt: 'Z paragonu',
        save: 'Zapisz {amount}',
    },
    shopping: {
        offlineListOnly: 'Bez zasięgu — pokazuję tylko tę listę.',
        loadFailed: 'Nie udało się wczytać rozpiski sklepu.',
        goShopping: 'Na zakupy',
        fallbackTitle: 'Zakupy',
        noStoreSubtitle: 'bez sklepu — sama ta lista',
        fromLists: 'z listy: {names} | z list: {names} | z list: {names}',
        nothingHere: 'nic tu nie masz do kupienia',
        scanUnknown: 'Nie znam tego kodu — odhacz ręcznie.',
        scanChecked: 'Odhaczone: {name}',
        scanNotOnList: '{name} — nie ma go na liście.',
        scanFailed: 'Nie udało się sprawdzić kodu.',
        finishOffline: 'Brak zasięgu — odhaczenia czekają w telefonie. Zakończysz, gdy wróci sieć.',
        finishFailed: 'Nie udało się zakończyć zakupów — spróbuj jeszcze raz.',
        label: 'Tryb zakupów',
        close: 'Zamknij tryb zakupów',
        changeStore: 'Zmień sklep',
        chooseStore: 'Wybierz sklep',
        scan: 'Skanuj kod produktu',
        offlinePending: 'Bez zasięgu · {n} czeka',
        sending: 'Wysyłam…',
        progress: '{done} z {total}',
        whereAreYou: 'Gdzie jesteś?',
        whereHint: 'Zobaczysz wszystko, co masz tam kupić, ze wszystkich list naraz — w kolejności półek tego sklepu.',
        listStore: 'sklep listy',
        nothing: 'nic',
        noStoreOption: 'Bez sklepu — tylko lista „{name}"',
        loading: 'Zbieram rozpiskę sklepu…',
        emptyStore: 'Nic tu nie masz do kupienia — dopisz coś poniżej albo zmień sklep.',
        emptyList: 'Lista jest pusta — dopisz coś poniżej.',
        substitute: 'Zamiennik:',
        price: 'Cena: {price}',
        lastPrice: 'Ostatnio: {price}',
        removeFromList: 'Usuń z listy',
        missingTitle: 'NIE BYŁO · ZOSTANIE NA LIŚCIE',
        elsewhereTitle: 'Gdzie indziej · {n}',
        elsewhereHint: 'Tego nie kupisz w tym sklepie — dział spoza jego rodzaju albo „tylko w" innym sklepie.',
        otherTitle: 'Z innych list, też tu dostaniesz · {n}',
        otherHint: 'Są na listach innych sklepów — możesz kupić je od razu.',
        addPlaceholder: 'Dopisz, np. 2 l mleko',
        addLabel: 'Dopisz pozycję',
        finishing: 'Kończę…',
    },
};
